module.exports = __webpack_public_path__ + "img/B1_Credit_Card.3ec2ae32.png";